import { useLocation } from "react-router-dom";

import classes from "./th.module.scss";

import { ReactComponent as TableArrowUpIcon } from "@/assets/images/icons/Table/up-arrow.svg";
import { ReactComponent as TableArrowDownIcon } from "@/assets/images/icons/Table/down-arrow.svg";
import { validRoles } from "@/services/Utils";
import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip";

const TableTh = ({
	item_name,
	item_description,
	item_size,
	item_order,
	order,
	setOrder,
	orderType,
	setOrderType,
	item_class,
	item_check_permission,
	only_admin,
	border_color,
	setAllOrder,
}) => {
	const location = useLocation();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);
	const isManager = validRoles(userRoles, ["administrador", "gerente_agricola"]);

	const handleArrowUp = () => {
		if (setAllOrder) {
			setAllOrder(item_order, "asc");
			return;
		}

		setOrder(item_order);
		setOrderType("asc");
	};

	const handleDownUp = () => {
		if (setAllOrder) {
			setAllOrder(item_order, "desc");
			return;
		}

		setOrder(item_order);
		setOrderType("desc");
	};

	if ((only_admin && !isAdmin) || (only_admin && location.pathname.includes("configuracion"))) {
		return <th style={{ display: "none" }}></th>;
	}

	if (item_check_permission && !isManager) {
		return <th style={{ display: "none" }}></th>;
	}

	return (
		<th
			style={{
				width: `${item_size}%`,
				textAlign: "center",
				padding: "5px",
				borderTop: "0px",
				borderBottom: border_color ? border_color : "0.5px solid #dee2e6",
				verticalAlign: "middle",
			}}
			className={item_class}
		>
			<div className={classes.label}>
				<div className={classes.textTitle}>{item_description ? <CustomTooltip text={item_name} description={item_description} /> : item_name}</div>
				{item_order && (
					<div
						style={{
							width: "25%",
							display: "inline-flex",
							flexDirection: "column",
						}}
					>
						<div>
							{item_order ? (
								<TableArrowUpIcon
									className={item_order === order && orderType === "asc" ? classes.iconArrowActive : classes.iconArrow}
									onClick={() => handleArrowUp()}
								/>
							) : (
								<div style={{ height: "21px" }}></div>
							)}
						</div>
						<div>
							{item_order ? (
								<TableArrowDownIcon
									className={item_order === order && orderType === "desc" ? classes.iconArrowActive : classes.iconArrow}
									onClick={() => handleDownUp()}
								/>
							) : (
								<div style={{ height: "21px" }}></div>
							)}
						</div>
					</div>
				)}
			</div>
		</th>
	);
};

export default TableTh;
